const Component = () => {
    return (
        <div id="info_coappCobor" className="pop_disable_bg">
            <div className="coBorrower_pop">
                <div className="pop_head">Co-Applicant Co-Borrower</div>
                <div className="pop_contentArea">
                    <div className="pop_contentHead">Select this option if you like to add the above co-applicant's spouse as a co-borrower</div>
                </div>
                <div className="pop_buttonLabel">
                    <input type="button" value="Close" className="pop_button" onClick={() => window.hide('info_coappCobor')} />
                </div>
            </div>
        </div>
    );
};

export default Component;